import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import { ROUTE_HOME } from "@/constants/routes.constants";
import SidebarChatsButton from "@/infrastructure/Sidebar/SidebarChats/sidebarChatButton.component";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import { ScrollArea } from "@/shadcn/components/ui/scroll-area";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import { RefreshCw } from "lucide-react";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

type SidebarChatsProps = {
  hideSidebar: () => void;
};

const SidebarChats: React.FC<SidebarChatsProps> = ({ hideSidebar }) => {
  const { conversations, refreshAllConversations } = useContext(AppContext);
  const { t } = useTranslation();
  const location = useLocation();
  const currPage = location.pathname || "home";

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex-shrink-0">
        <div className="flex w-full items-center justify-between px-2 py-1 text-sm font-bold">
          <span>{t("Chats")}</span>
          <TooltipProvider>
            <Tooltip delayDuration={200}>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  className="h-6 w-6 p-0"
                  onClick={async () => {
                    await refreshAllConversations();
                  }}
                >
                  <RefreshCw className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{t("Refresh")}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <ScrollArea className="w-full flex-1 grow overflow-hidden">
        <div className="grid gap-1 p-1">
          {conversations.length === 0 ? (
            <div className="flex w-full items-center justify-center text-sm">
              {t("No conversations yet")}
            </div>
          ) : (
            conversations.map((chat) => (
              <ErrorBoundary key={chat.id} fallback={<div>Error</div>}>
                <SidebarChatsButton
                  key={chat.id}
                  chat={chat}
                  isCurrPage={currPage === `${ROUTE_HOME}/${chat.id}`}
                  hideSidebar={hideSidebar}
                />
              </ErrorBoundary>
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
};

export default SidebarChats;
